module.exports = __webpack_public_path__ + "static/media/img_4.73329e08.png";